module.exports = __webpack_public_path__ + "static/media/expert_advice.633347af.svg";